// extracted by mini-css-extract-plugin
export default {"others-header":"Header_others-header__WiBVC","others-header__buttons":"Header_others-header__buttons__3ZV3t"};